'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        messagesToolsMoveDown: {
            type: String,
            kComposite: 'messages.tools.moveDown'
        },
        messagesToolsMoveUp: {
            type: String,
            kComposite: 'messages.tools.moveUp'
        },
        messagesToolsRemove: {
            type: String,
            kComposite: 'messages.tools.remove'
        },
        messagesToolsTransferAllFrom: {
            type: String,
            kComposite: 'messages.tools.transferAllFrom'
        },
        messagesToolsTransferAllTo: {
            type: String,
            kComposite: 'messages.tools.transferAllTo'
        },
        messagesToolsTransferFrom: {
            type: String,
            kComposite: 'messages.tools.transferFrom'
        },
        messagesToolsTransferTo: {
            type: String,
            kComposite: 'messages.tools.transferTo'
        }
    }
};